import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Box from '@ntuctech/devex-tangram/Box';

const FormActionsSC = styled(Box)`
  justify-content: center;
  display: flex;
  flex-wrap: wrap;

  button {
    width: 13.5rem;
  }

  @media (max-width: ${(props) => `${parseInt(props.theme.SizeBreakpointsS, 10) - 1}px`}) {
    margin: 1.5rem 0;
  }
`;

function FormActions({ children }) {
  return (
    <FormActionsSC className="SSOFormAction" mb={4} mt={4}>
      {children}
    </FormActionsSC>
  );
}

FormActions.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormActions;
